import React from 'react';
import { CTAButton } from './CTAButton';
import { ArrowRightCircle, XCircle } from 'lucide-react';
export function CloseSection() {
  return <section className="py-24 px-4 bg-cream-dark" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-brown mb-16" data-id="element-3">
          You have two paths in front of you:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-4">
          {/* Path A */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark opacity-75 hover:opacity-100 transition-opacity" data-id="element-5">
            <div className="flex items-center gap-3 mb-6 text-coral-dark" data-id="element-6">
              <XCircle className="w-8 h-8" data-id="element-7" />
              <h3 className="font-heading font-bold text-2xl" data-id="element-8">Path A</h3>
            </div>
            <p className="text-brown-light font-body leading-relaxed" data-id="element-9">
              Keep trying to survive day by day, feeling increasingly
              disconnected from yourself, exhausted, and resigned that "this is
              your new reality."
            </p>
          </div>

          {/* Path B */}
          <div className="bg-white p-8 rounded-2xl shadow-warm-lg border-2 border-sage relative transform md:-translate-y-4" data-id="element-10">
            <div className="absolute -top-4 right-8 bg-sage text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-11">
              Recommended
            </div>
            <div className="flex items-center gap-3 mb-6 text-sage" data-id="element-12">
              <ArrowRightCircle className="w-8 h-8" data-id="element-13" />
              <h3 className="font-heading font-bold text-2xl" data-id="element-14">Path B</h3>
            </div>
            <p className="text-brown font-body leading-relaxed font-medium" data-id="element-15">
              Take control today. Use science and strategy to become that
              vibrant, focused, and happy woman your baby deserves to have as a
              mother.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-16">
          <CTAButton onClick={() => window.open('https://woman90dayprotocol.com/cart/48957448421616:1', '_blank')} className="w-full sm:w-auto text-lg md:text-xl py-5 px-8 md:px-12" data-id="element-17">
            YES, I WANT TO RECLAIM MY IDENTITY AND ENERGY — $6.39
          </CTAButton>
        </div>
      </div>
    </section>;
}